import { createSelector } from 'reselect';
import { getOperationalStatus } from './getOperationalStatus';
import { OPERATIONAL_STATUS_ENUM } from '../constants';

export const getIsWaitingForOperator = createSelector(
  [getOperationalStatus],
  (status) => {
    return status === OPERATIONAL_STATUS_ENUM.WAITING_FOR_OPERATOR;
  }
);
